import Vue from 'vue'
import Vue2Storage from 'vue2-storage'

Vue.use(Vue2Storage)

const ttl = {ttl: 60 * 60 * 1000}

export default {
    mutations: {
        signIn(state, user) {
            state.isAuth = true
            state.user = user
            state.token = user.token
            state.role = user.type
            state.bonus = user.new_bonus

            if (user.type === 'client') {
                window.location.href = '/cabinet/client/settings'
            } else if (user.type === 'master') {
                window.location.href = '/cabinet/master/settings'
            } else if (user.type === 'admin') {
                window.location.href = '/cabinet/admin/calendar'
            }

            Vue.$storage.set('user', user, ttl)
            Vue.$storage.set('bonus', user.new_bonus, ttl)
            Vue.$storage.set('token', user.token, ttl)
        },
        signOut(state) {
            state.isAuth = false
            state.user = null
            state.token = null
            state.role = null

            Vue.$storage.remove('user')
            Vue.$storage.remove('token')
            Vue.$storage.remove('bonus')
        },
        setIsAuth(state, isAuth) {
            state.isAuth = isAuth
        },
        setUser(state, user) {
            state.user = user
            state.role = user ? user.type : null

            Vue.$storage.set('user', user, ttl)
        },
        setToken(state, token) {
            state.token = token
            Vue.$storage.set('token', token, ttl)
        },
        setBonus(state, bonus) {
            state.bonus = bonus
            Vue.$storage.set('bonus', bonus, ttl)
        },
        setMessage(state, message) {
            state.user.new_message = message;
            Vue.$storage.set('user', state.user, ttl)
        },
    },
    state: {
        bonus: Vue.$storage.get('bonus'),
        user: Vue.$storage.get('user'),
        token: Vue.$storage.get('token'),
        isAuth: !!Vue.$storage.get('token'),
        role: Vue.$storage.get('user') ? Vue.$storage.get('user').type : null
    },
    getters: {
        hasCoworking(state) {
            return state.user && state.user.coworking
        },
        isUserAuth(state) {
            return state.isAuth
        },
        getUser(state) {
            return state.user
        },
        getToken(state) {
            return state.token
        },
        getRole(state) {
            return state.role
        },
        getBonus(state) {
            return state.bonus
        },
        isAdmin(state) {
            return state.role && state.role === 'admin'
        },
        isClient(state) {
            return state.role && state.role === 'client'
        },
        isMaster(state) {
            return state.role && state.role === 'master'
        },
    }
}
